import React from 'react';
const { m } = require('framer-motion');
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import Image from '../../components/Image';
import { formatUTCDate } from '@/locales/dates';

function EventResumeHeader({ event }) {
  const {
    location: { venue },
  } = event;
  const {
    event: { start_date, name, banner },
  } = event;
  const date = formatUTCDate(start_date, 'dddd, DD MMMM YYYY. h:mm A');

  return (
    <Stack direction="row" spacing={2}>
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 48,
          borderRadius: '4px',
          overflow: 'hidden',
        }}
      >
        <Image src={banner} ratio="1/1" />
      </Box>

      <Box sx={{ flexGrow: 1, minWidth: 160 }}>
        <Typography variant="subtitle2">{name}</Typography>
        <Stack direction="column" sx={{ color: 'text.secondary' }}>
          <Typography
            variant="caption"
            sx={{ fontWeight: 400, textTransform: 'capitalize' }}
          >
            {date}
          </Typography>
          <Typography variant="caption" sx={{ fontWeight: 400 }}>
            {venue}
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
}

EventResumeHeader.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventResumeHeader;
